// API service functions for dashboard pages
import api from './client';

export interface DashboardPage {
  id: number;
  page_id: string;
  page_name: string;
  page_path: string;
  page_icon: string;
  description?: string;
  category?: string;
  is_active: boolean;
  created_at: string;
}

export interface DashboardPageCreate {
  page_id: string;
  page_name: string;
  page_path: string;
  page_icon: string;
  description?: string;
  category?: string;
  is_active?: boolean;
}

export interface DashboardPageUpdate {
  page_name?: string;
  page_path?: string;
  page_icon?: string;
  description?: string;
  category?: string;
  is_active?: boolean;
}

export interface DashboardComponent {
  id: number;
  component_id: string;
  component_name: string;
  page_id: string;
  description?: string;
  component_type?: string;
  api_endpoints?: string;
  is_active: boolean;
  created_at: string;
}

export interface PageWithComponents {
  id: number;
  page_id: string;
  page_name: string;
  page_path: string;
  page_icon: string;
  description?: string;
  category?: string;
  is_active: boolean;
  created_at: string;
  components: DashboardComponent[];
}

export const pageApi = {
  // Create a new dashboard page
  create: async (data: DashboardPageCreate): Promise<DashboardPage> => {
    const response = await api.post('/v1/pages/', data);
    return response.data;
  },

  // List all dashboard pages
  list: async (skip = 0, limit = 100): Promise<DashboardPage[]> => {
    const response = await api.get(`/v1/pages/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  // Get a specific dashboard page
  get: async (page_id: string): Promise<DashboardPage> => {
    const response = await api.get(`/v1/pages/${page_id}`);
    return response.data;
  },

  // Update a dashboard page
  update: async (page_id: string, data: DashboardPageUpdate): Promise<DashboardPage> => {
    const response = await api.put(`/v1/pages/${page_id}`, data);
    return response.data;
  },

  // Delete a dashboard page
  delete: async (page_id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/pages/${page_id}`);
    return response.data;
  },

  // Get components for a specific page
  getComponents: async (page_id: string): Promise<DashboardComponent[]> => {
    const response = await api.get(`/v1/pages/${page_id}/components`);
    return response.data;
  },

  // Get all pages with their components
  getPagesWithComponents: async (skip = 0, limit = 100): Promise<PageWithComponents[]> => {
    const response = await api.get(`/v1/pages/with-components/?skip=${skip}&limit=${limit}`);
    return response.data;
  }
};
